
import {
    AppButton,
    AppCard,
    AppDateTimePicker,
    AppFileUpload,
    AppImageHolder,
    AppFormRow,
    AppInput,
    AppSelect
} from '@/components';
import { useNewsAdd } from '@/modules/news/model/add';
import { NewsOptions } from '@/modules/news/model/mixins';
import { ROUTE_NAME_NEWS } from '@/modules/news/router';
import { defineComponent, onMounted } from 'vue';

export default defineComponent({
    name: ROUTE_NAME_NEWS.ADD,
    components: {
        AppCard,
        AppFormRow,
        AppButton,
        AppDateTimePicker,
        AppFileUpload,
        AppImageHolder,
        AppSelect,
        AppInput
    },
    setup() {
        const { model, v$, actions, appSelectOptions, fetchItem } = useNewsAdd();

        onMounted(async () => {
            await fetchItem();
        });

        return { model, v$, NewsOptions, appSelectOptions, actions };
    }
});
